// The homepage's button language (see HeroSection): outlined, hard offset
// shadow that the button "lands" into when pressed.
export const FOCUS_RING =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 focus-visible:ring-offset-paper";

export const BUTTON_CLASSES =
  "inline-flex h-12 items-center gap-2 rounded-[12px] border border-char bg-brand-600 px-6 font-sans text-[15px] font-semibold text-white shadow-offset " +
  "transition-[transform,box-shadow] duration-150 hover:-translate-x-0.5 hover:translate-y-0.5 hover:shadow-[-3px_4px_0_0_#262524] " +
  "active:-translate-x-[5px] active:translate-y-[6px] active:shadow-none disabled:opacity-60 " +
  FOCUS_RING;
